export default "__VITE_ASSET__CuFXxqAD__"